<template>
	<div ref="content" class="content background2">
		<div ref="btnList" style="display: flex;justify-content: space-between;">
			<BtnList style="width: 35%;" ref="btn" :btnList="btnList"></BtnList>
			<BtnList ref="btn" :btnList="btnList1"></BtnList>
		</div>
		<div ref="tableList" class="list" :style="{'padding-top':paddingTop}"
			style="display: flex;justify-content: space-between;">
			<List ref="list1" style="width: 35%;" refName="refList1" :tableData="tableData" :tableList="tableList"
				:pageSize="pageSize" :pageNo="pageNo" @parentMethod="getInfo"></List>
			<List ref="list2" :tableData="tableData1" refName="refList2" :tableList="tableList1" :pageSize="pageSize"
				:pageNo="pageNo" @parentMethod="getInfoMes"></List>
		</div>
		<div ref="page" class="page">
			<Page ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
				@parentMethod="search"></Page>
		</div>
	</div>
</template>

<script>
	import "@/assets/css/common/list.css"
	import SearchList from "@/components/list/searchList";
	import BtnList from "@/components/list/btnList";
	import List from "@/components/list/list";
	import Page from "@/components/common/page";
	import User from "@/assets/js/system/user.js";
	export default {
		name: 'list',
		components: {
			List,
			SearchList,
			BtnList,
			Page
		},
		data() {
			const $this = this;
			return {
				paddingTop: 0,
				btnList: [],
				btnList1: [],
				tableList: [{
					column: 'name',
					title: '字典名称',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}, {
					column: 'type',
					title: '字典类型',
					headerAlign: 'center',
					align: 'center',
					termList: [{
							'id': 1,
							'name': '系统',
						},
						{
							'id': 2,
							'name': '业务',
						},
					],
					width: '20%'
				}],
				tableList1: [{
					column: 'value',
					title: '值',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}, {
					column: 'rank',
					title: '排序',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}, {
					column: 'value1',
					title: '名称1',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}, {
					column: 'value2',
					title: '名称2',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}, {
					column: 'value3',
					title: '名称3',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}, {
					column: 'value4',
					title: '名称4',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}],
				tableData: [],
				tableData1: [],
				tableInfo: {},
				tableInfoMes: {},
				pageCount: 0,
				pageSize: 0,
				pageNo: 1,
			}
		},
		methods: {
			queryArea() {},
			getDictionaryList() {
				User.getDictionaryList().then((response) => {
					const data = response.data;
					this.tableData = data.data;
					if (this.tableData != "") {
						let mes = {
							pageNo: 1,
							pageSize: this.pageSize,
						}
						this.tableInfo = this.tableData[0];
						this.getDictionaryMes(mes, this.tableData[0].id)
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			getDictionaryMes(mes, id) {
				User.getDictionaryMes(mes, id).then((response) => {
					const data = response.data;
					this.pageCount = data.data.total;
					this.pageNo = data.data.current;
					this.$refs['pageModel'].setCurrent(this.pageNo);
					this.tableData1 = data.data.records;
				}).catch((response) => {
					console.log(response)
				})
			},
			search(param) {
				//var dataParam = this.$refs.searchContent.getSearchParam();
				this.getDictionaryList();
			},
			getWindowHeight() {
				let height = '';
				height = this.$refs.tableList.clientHeight - (this.$refs.btnList.clientHeight +
					20) - 60;
				this.height = height;
				if (height > 550) {
					let line = parseInt((height - 10) / 50);
					if (this.pageSize != line) {
						this.pageSize = line;
					}
				} else {
					if (this.pageSize != 10) {
						this.pageSize = 10;
					}
				}
				this.search({
					pageNo: 1,
					pageSize: this.pageSize
				});
			},
			getInfo(info) {
				this.tableInfo = info;
				let mes = {
					pageNo: 1,
					pageSize: this.pageSize,
				}
				this.getDictionaryMes(mes, this.tableInfo.id)
			},
			getInfoMes(info) {
				this.tableInfoMes = info;
			}
		},
		created() {
			this.menuList = this.$store.getters.getMenuPermission;
			const $this = this;
			if (this.menuList.indexOf("CD_671") != -1) {
				this.btnList.push({
					btnLabel: '新增',
					btnType: 1,
					btnPosition: 'left',
					title: '新增',
					columnList: [{
							columnLabel: '字典名称',
							value: '',
							column: 'name',
							columnType: 0,
							placeholder: '请输入字典名称',
						},
						{
							columnLabel: '字典类型',
							value: '',
							column: 'type',
							columnType: 1,
							placeholder: '请选择',
							columnTermList: [{
								id: 1,
								name: '系统'
							}, {
								id: 2,
								name: '业务'
							}],
						}
					],
					btnClick: function(tip) {
						tip();
						$this.btnList[0].columnList.forEach(function(item, index) {
							item.value = '';
						})
					},
					btnFun: function(tip, info) {
						User.AddDictionary(info).then((response) => {
							const data = response.data;
							if (data.code == 1) {
								$this.utils.saveAlert();
								$this.search();
								$this.btnList[0].columnList.forEach(function(item, index) {
									item.value = '';
								})
								tip()
							} else {
								$this.utils.tipsAlert(data.message);
							}
						}).catch((response) => {
							console.log(response)
						})
					}
				});
				this.btnList1.push({
					btnLabel: '新增',
					btnType: 1,
					btnPosition: 'left',
					title: '新增',
					columnList: [{
							columnLabel: '值',
							value: '',
							column: 'value',
							columnType: 0,
							placeholder: '请输入值',
						},
						{
							columnLabel: '排序',
							value: '',
							column: 'rank',
							columnType: 0,
							placeholder: '请输入排序',
						},
						{
							columnLabel: '值1',
							value: '',
							column: 'value1',
							columnType: 0,
							placeholder: '请输入值1',
						},
						{
							columnLabel: '值2',
							value: '',
							column: 'value2',
							columnType: 0,
							placeholder: '请输入值2',
						},
						{
							columnLabel: '值3',
							value: '',
							column: 'value3',
							columnType: 0,
							placeholder: '请输入值3',
						},
						{
							columnLabel: '值4',
							value: '',
							column: 'value4',
							columnType: 0,
							placeholder: '请输入值4',
						},
					],
					btnClick: function(tip) {
						tip();
						$this.btnList1[0].columnList.forEach(function(item, index) {
							item.value = '';
						})
					},
					btnFun: function(tip, info) {
						info.dictId = $this.tableInfo.id;
						info.rank = Number(info.rank)
						User.AddDictionaryMes(info).then((response) => {
							const data = response.data;
							if (data.code == 1) {
								$this.utils.saveAlert();
								let mes = {
									pageNo: 1,
									pageSize: $this.pageSize,
								}
								$this.getDictionaryMes(mes, info.dictId)
								$this.btnList1[0].columnList.forEach(function(item, index) {
									item.value = '';
								})
								tip()
							} else {
								$this.utils.tipsAlert(data.message);
							}
						}).catch((response) => {
							console.log(response)
						})
					}
				});
			}
			if (this.menuList.indexOf("CD_672") != -1) {
				this.btnList.push({
					btnLabel: '编辑',
					btnType: 4,
					btnPosition: 'left',
					title: '编辑',
					columnList: [{
							columnLabel: '字典名称',
							value: '',
							column: 'name',
							columnType: 0,
							placeholder: '请输入字典名称',
						},
						{
							columnLabel: '字典类型',
							value: '',
							column: 'type',
							columnType: 1,
							placeholder: '请选择',
							columnTermList: [{
								id: 1,
								name: '系统'
							}, {
								id: 2,
								name: '业务'
							}],
						}
					],
					btnClick: function(tip) {
						if (Object.keys($this.tableInfo).length > 0) {
							tip();
							$this.btnList[1].columnList.forEach(function(item, index) {
								item.value = $this.tableInfo[item.column];
							})
						} else {
							$this.utils.tipsAlert('请选择数据');
						}
					},
					btnFun: function(tip, info) {
						info.id = $this.tableInfo.id
						User.UpdateDictionary(info).then((response) => {
							const data = response.data;
							if (data.code == 1) {
								$this.utils.editAlert();
								$this.search();
								tip()
							} else {
								$this.utils.tipsAlert(data.message);
							}
						}).catch((response) => {
							console.log(response)
						})
					}
				});
				this.btnList1.push({
					btnLabel: '编辑',
					btnType: 4,
					btnPosition: 'left',
					title: '编辑',
					columnList: [{
							columnLabel: '值',
							value: '',
							column: 'value',
							columnType: 0,
							placeholder: '请输入值',
						},
						{
							columnLabel: '排序',
							value: '',
							column: 'rank',
							columnType: 0,
							placeholder: '请输入排序',
						},
						{
							columnLabel: '值1',
							value: '',
							column: 'value1',
							columnType: 0,
							placeholder: '请输入值1',
						},
						{
							columnLabel: '值2',
							value: '',
							column: 'value2',
							columnType: 0,
							placeholder: '请输入值2',
						},
						{
							columnLabel: '值3',
							value: '',
							column: 'value3',
							columnType: 0,
							placeholder: '请输入值3',
						},
						{
							columnLabel: '值4',
							value: '',
							column: 'value4',
							columnType: 0,
							placeholder: '请输入值4',
						},
					],
					btnClick: function(tip) {
						if (Object.keys($this.tableInfoMes).length > 0) {
							tip();
							$this.btnList1[1].columnList.forEach(function(item, index) {
								item.value = $this.tableInfoMes[item.column];
							})
						} else {
							$this.utils.tipsAlert('请选择数据');
						}
					},
					btnFun: function(tip, info) {
						info.dictId = $this.tableInfoMes.dictId;
						info.id = $this.tableInfoMes.id;
						info.rank = Number(info.rank);
						User.UpdateDictionaryMes(info).then((response) => {
							const data = response.data;
							if (data.code == 1) {
								$this.utils.editAlert();
								let mes = {
									pageNo: 1,
									pageSize: $this.pageSize,
								}
								$this.getDictionaryMes(mes, info.dictId)
								tip()
							} else {
								$this.utils.tipsAlert(data.message);
							}
						}).catch((response) => {
							console.log(response)
						})
					}
				});
			}
			if (this.menuList.indexOf("CD_673") != -1) {
				this.btnList.push({
					btnLabel: '删除',
					btnType: 0,
					btnPosition: 'left',
					btnFun: function() {
						if (Object.keys($this.tableInfo).length > 0) {
							$this.$confirm('是否删除这个字典类别?', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
								var info = [$this.tableInfo.id]
								User.deleteDictionary(info).then((response) => {
									const data = response.data;
									if (data.code == 1) {
										$this.utils.delAlert();
									} else {
										$this.utils.tipsAlert(data.message);
									}
									$this.search({
										pageNo: 1,
										pageSize: $this.pageSize
									});
								}).catch((response) => {})
							});
						} else {
							$this.utils.tipsAlert('请选择数据');
						}
					}
				});
				this.btnList1.push({
					btnLabel: '删除',
					btnType: 0,
					btnPosition: 'left',
					btnFun: function() {
						if (Object.keys($this.tableInfoMes).length > 0) {
							$this.$confirm('是否删除这个字典内容?', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
								var info = [$this.tableInfoMes.id]
								User.deleteDictionaryMes(info).then((response) => {
									const data = response.data;
									if (data.code == 1) {
										let mes = {
											pageNo: 1,
											pageSize: $this.pageSize,
										}
										$this.getDictionaryMes(mes, $this.tableInfoMes.dictId)
										$this.utils.delAlert();
									} else {
										$this.utils.tipsAlert(data.message);
									}
								}).catch((response) => {
									console.log(response)
								})
							});
						} else {
							$this.utils.tipsAlert('请选择数据');
						}
					}
				});
			}
		},
		mounted() {
			this.paddingTop = (this.$refs.btnList.clientHeight + 20) + 'px';
			this.getWindowHeight();
			window.onresize = () => {
				this.getWindowHeight();
				this.$refs.list1.getHeight();
				this.$refs.list2.getHeight();
			}
		}
	}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/system/dictionary.vue